export const officialUrl='https://www.ccwork.com.cn';

export const registerUrl='https://www.ccwork.com.cn/server/html/register.html'

export const openPlatformUrl="https://easydoc.soft.360.cn/doc?project=93d8e8f4464727f0d48e5a8993ce7d62&config=title_menu_toc"

export const onlineServiceUrl="https://p.qiao.baidu.com/cps/chat?siteId=17637950&userId=30619335&siteToken=4b4a0bfc97fd28a4454369f4d9ba5967&plan=gwbt1"

export const onlineContactUrl="https://p.qiao.baidu.com/cps/chat?siteId=17637950&userId=30619335&siteToken=4b4a0bfc97fd28a4454369f4d9ba5967&plan=gwbt2"